import axios from "axios";

const post = async args => {
    let result = await request('POST', args);
    return result;
};

const get = async args => {
    let result = await request('GET', args);
    return result;
};

const request = async (method, args) => {
    let {url, absoluteUrl, service, body, headers, mode} = args;
    headers = headers || [];
    service = service || 'main';
    url = !absoluteUrl ? window.endpoint(service, url) : absoluteUrl;
    body = body || {};
    let userId = localStorage.getItem('userId');
    let accessToken = localStorage.getItem('accessToken');
    let timezoneOffset = new Date().getTimezoneOffset();

    headers = {...headers, userId, accessToken, timezoneOffset, x: 'y'};
    /*if ( mode === 'b' ) {
        body.append(key, value);
    } else {
        body[key] = value;
    }*/

    console.log(headers)

    let result = {data: {}};
    await axios.post(url, body, {headers})
        .then(response => {
            if ( typeof response.data !== 'undefined') {
                if ( response.data.notification ) {
                    window.Messenger.broadcast('DisplayNotification', response.data.notification);
                } else if ( response.data.hasErrors ) {
                    window.Messenger.broadcast('DisplayNotification', {type: 'error', message: response.data.errors || response.data.message});
                } else {
                    result = response.data;
                    if ( typeof result === 'object' ) {
                        result.success = true;
                    }
                    return result;
                }
            }
        })
        .catch(error => {
            // FL-011: reports (and other Http callers) must send the user to sign-in on auth
            // failure — not hang/blank or toast only.
            const status = error && error.response && error.response.status;
            const msg = String(
                (error && error.response && error.response.data && (error.response.data.message || error.response.data.error)) ||
                (error && error.message) ||
                ''
            ).toLowerCase();
            const authFailure =
                status === 401 ||
                status === 403 ||
                msg.includes('unauthorized') ||
                msg.includes('unauthenticated') ||
                msg.includes('access token') ||
                msg.includes('not signed in');
            if (authFailure && window.location.href.indexOf('/signin') === -1) {
                window.location.assign('/signin?.r=timeout');
                return result;
            }
            console.log(error);
            return result;
        });
    return result;
};

const Http = {
    post,
    get
};

export default Http;